/** Web login + sign up (Supabase). Mobile app download landing uses /signin. */
export const WEB_LOGIN_PATH = "/login";
